module.exports = __webpack_public_path__ + "img/sixpackcarrier14.53731bdb.jpg";